// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3-kUo","fullView":"styles_fullView__sBNAg","shimmer":"styles_shimmer__p6YM1"};